import { Button } from '@mui/material'
import theme from 'src/styles/theme'
import styled from 'styled-components'

export const Header = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
`

export const FiltersButton = styled(Button)`
    background: ${theme.colors.blue} !important;
    color: ${theme.colors.white} !important;
    display: flex;
    gap: 4px;
`
